<template class="template">
  
  <div id="" class="" style="">

    <!--pagina valida persona-->
    <ValidaPersona v-if="validacion" />

    <!-- Pagina avion -->
    <Desafio v-if="desafio" />

    <!-- opps -->
    <Opps v-if="opps" />

    <!-- avance -->
    <Avance v-if="avance" />
    
    <!-- Felicitaciones -->
    <Felicitaciones v-if="felicitaciones" />

    <!-- Desafio exclusivo -->
    <DesafioExclusivo v-if="desafioExclusivo"/>

    <!-- Ya registrado -->
    <YaRegistrado v-if="yaRegistrado"/>

    <!-- Periodo finalizado -->
    <PeriodoFinalizado v-if="finalizado"/>
    
    <noRegistrado v-if="noRegistrado"/>

  </div>
</template>

<script>
import Desafio from "./components/desafio.vue";
import ValidaPersona from "./components/validaPersona.vue";
import Opps from "./components/opps.vue";
import Felicitaciones from "./components/felicitaciones.vue";
import DesafioExclusivo from "./components/desafioExclusivo.vue"
import YaRegistrado from "./components/yaRegistrado.vue"
import PeriodoFinalizado from "./components/periodoFinalizado.vue"
import Avance from "./components/avance.vue"
import noRegistrado from "./components/noRegistrado.vue"

export default {
  name: "App",
  data() {
    return {
      loading: false,
      rut: "",
    };
  },
  computed: {
    validacion(){
      return this.$store.state.mostrarValidacion;
    },
    desafio(){
      return this.$store.state.mostrarDesafio;
    },
    opps(){
      return this.$store.state.mostrarOpps;
    },
    avance(){
      return this.$store.state.mostrarAvance;
    },
    felicitaciones(){
      return this.$store.state.mostrarFelicitaciones;
    },
    desafioExclusivo(){
      return this.$store.state.mostrarDesafioExclusivo;
    },
    yaRegistrado(){
      return this.$store.state.mostrarYaRegistrado;
    },
    finalizado(){
      return this.$store.state.mostrarFinalizado;
    },
    avance(){
      return this.$store.state.mostrarAvance;
    },
    noRegistrado(){
      return this.$store.state.mostrarNoRegistrado;
    },
  },
  components: {
    Desafio,
    ValidaPersona,
    Opps,
    Felicitaciones,
    DesafioExclusivo,
    YaRegistrado,
    PeriodoFinalizado,
    Avance,
    noRegistrado
  },
  methods: {},
  created(){
    var url = window.location.search;
    const urlParams = new URLSearchParams(url);
    var origen = urlParams.get('org');
    if(origen !=''&& origen != null){
      this.$store.commit('SET_ORIGEN',origen);
    }else{
      this.$store.commit('SET_ORIGEN','OrigenDesconocido');
    }
    window.scrollTo(0,0);
  }
};
</script>

<style>

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

.grayText {
  color: #a0a0a0;
}
.opcion {
  border-radius: 10px;
  padding: 10px;
  margin-top: 5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Gotham", sans-serif;
  color: white;
}

.opcionMeta {
  background-color: #c0a161;
  border-radius: 10px;
  padding: 10px;
  margin-top: 5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Gotham", sans-serif;
  color: white;
}

.fondo {
  background: linear-gradient(to bottom, #005d9a, #01aff4);

}
.header {
  text-align: center;
  margin: 0%;
  padding: 1rem;
}
.imagen {
  height: 100%;
  width: 550px;
}

input.transparent-input {
  background-color: transparent !important;
  border: none !important;
}

.form-rounded {
  border-radius: 1rem;
}

.trasparente {
  text-align: center;
  margin-right: 0%;
  display: inherit;
}

.right {
  text-align: right;
  align-items: flex-end;
  align-content: flex-end;
}

.radio-label {
  display: inline-block;
  vertical-align: top;
  margin-right: 3%;
}
.radio-input {
  display: inline-block;
  vertical-align: top;
}

.div {
  display: inherit;
}
.body {
  background-color: #1a1a1a;
}

section {
  background-color: black !important;
  color: white !important;
}
.box-content {
  padding: 1.5rem;
  margin-right: 0;
  margin-left: 0;
  border-width: 1px;
  background-color: #ff6400;
}
.error {
  color: white;
}
.naranjo {
  color: #ff6400 !important;
}
.btn-inscribir {
  background-color: white;
  border: none;
}
.btn-inscribir-latam {
  border: none;
  color: black;
  text-align: center;
  width: 40%;
  margin-top: 2%;
}
.icono {
  width: 15%;
}
.iconoAvion {
  width: 22%;
}
.loader {
  /* Loader Div Class */
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #eceaea;
  opacity: 0.5;
  filter: alpha(opacity=40);
}
.btn-inscribir-orange {
  background-color: #00ffe6;
  border: none;
  color: black;
  align-content: left;
  text-align: center;
  width: 70%;
  font-size: 40px;
}
.btn-inscribir-nuevo {
  background-color: #d7332a;
  border: none;
  color: white;
  align-content: left;
  text-align: center;
  width: 70%;
  font-size: 20px;
  padding: 3%;
  font-weight: 700;
}
.btn-inscribir-nuevo:hover {
    background-color: white;
    color: #d7332a;
    font-weight:bolder;
  }
html * {
  font-family: "Gotham", sans-serif;
}
.bold,
strong {
  font-weight: 700;
}
.normal {
  font-family: "Gotham";
  font-weight: 600;
  font-style: normal;
}
.ultra {
  font-family: "Gotham Black";
  font-weight: 500;
  font-style: normal;
}
.text-white {
  color: white;
}
.link-hover-bg {
  text-decoration: none;
}

/* ///////////////// */

.form-check {
  padding-left: 0 !important;
}

input.radio-input {
  width: 30px;
  height: 20px;
}

input.radio-input:checked {
  color: red;
}

.contenedor-datos {
  width: 50%;
  margin: auto;
}

.header img {
  width: 15%;
}

.footer {
  background-color: #1a1a1a;
  text-align: center;
  margin: 0%;
  height: 100%;
  padding: 2rem;
}

.footer img {
  width: 30%;
}

.footer-desafio {
  background-color: #1a1a1a;
  text-align: center;
  margin: 0%;
  height: 100%;
}
.footer-desafio img {
  width: 50%;
}

.img-oops {
  width: 70%;
  margin: auto;
}

.img-inscribir-latam {
  width: 80%;
  margin-top: 2rem;
}

@media (max-width: 768px) {
  .header img {
    width: 50%;
  }
  .contenedor-datos {
    width: 100%;
    margin: auto;
  }
  .footer img {
    width: 100%;
    padding: 0;
  }
  .footer-desafio img {
    width: 100%;
    padding: 1rem;
  }
  .img-oops {
    width: 100%;
  }

  .img-inscribir-latam {
    width: 100%;
    margin-top: 2rem;
  }
}

/* ///////////////// */

@media (min-width: 1495px) {
  .desktop {
    width: 70%;
  }
  .heightFooter{
    height:100%
  }
}
@media (max-width: 1125px) {
  .body{
    background-color: #1a1a1a;
  }
  .heightFooter{
    height:100%;
  }
}
@media (max-width: 360px) {
  .btn-inscribir-orange {
  border: none;
  color: white;
  align-content: left;
  text-align: center;
  width: 100%;
  font-size: 20px;
}
}
</style>
